declare global {
  interface Window {
    __mapsCallback?: () => void;
  }
}

let loadPromise: Promise<void> | null = null;

export const loadGoogleMaps = (): Promise<void> => {
  if (window.google?.maps) {
    return Promise.resolve();
  }

  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      const apiKey = (import.meta as any).env.VITE_GOOGLE_MAPS_API_KEY;

      if (!apiKey) {
        reject(new Error('Google Maps API key not configured'));
        return;
      }

      window.__mapsCallback = () => resolve();

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&callback=__mapsCallback&libraries=geometry,marker`;
      script.async = true;

      script.onerror = () => reject(new Error('Failed to load Google Maps API'));

      document.head.appendChild(script);
    });
  }

  return loadPromise;
};
